var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 822,
    height: 352,
    viewBox: "0 0 822 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.4 14.6447C224.841 5.22535 201.031 0 176 0C78.7979 0 0 78.7979 0 176C0 273.202 78.7979 352 176 352C201.031 352 224.841 346.775 246.4 337.355C184.24 310.196 140.8 248.171 140.8 176C140.8 103.829 184.24 41.8035 246.4 14.6447Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.8 337.355C430.64 310.197 387.2 248.171 387.2 176C387.2 103.829 430.64 41.8034 492.8 14.6447C471.241 5.22533 447.431 0 422.4 0C325.198 0 246.4 78.7979 246.4 176C246.4 273.202 325.198 352 422.4 352C447.431 352 471.241 346.775 492.8 337.355Z",
    fill: "#56CD9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 657.067,
    cy: 176,
    r: 153.267,
    stroke: "#2B323B",
    strokeWidth: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.667e54f85eb05560572a53bdf1cf42e0.svg";
export { ForwardRef as ReactComponent };